import { Injectable } from '@angular/core'
import { NavService } from '../services/nav.service'
import { AppRoutingConfig } from './app.routing.config'

@Injectable({
  providedIn: 'root',
})
export class KeySystemNavConfig {
  constructor(private navService: NavService) {}

  setNav(activeName, structure, keySystem) {
    const navButtons = [
      {
        name: 'Dashboard',
        active: false,
        icon: 'layout',
        router: AppRoutingConfig.getGenericUrl('structure', structure.id, keySystem.id),
      },
    ]

    const keySystemButton = {
      name: 'Key System',
      active: false,
      icon: 'key',
      router: AppRoutingConfig.getGenericUrl('structureHierarchy', structure.id, keySystem.id),
    }

    const dealerNavButton = {
      name: 'Dealer',
      active: false,
      icon: 'report',
      router: AppRoutingConfig.getGenericUrl('dealerMasterKey', structure.id, keySystem.id),
    }

    const budgetNavButton = {
      name: 'Budget',
      active: false,
      icon: 'legal',
      router: AppRoutingConfig.getGenericUrl('structureBudget', structure.id, keySystem.id),
    }

    if (
      keySystem.statusId !== 2 &&
      keySystem.statusId !== 3 &&
      keySystem.statusId !== 6 &&
      keySystem.statusId !== 7 &&
      keySystem.statusId !== 11
    ) {
      navButtons.push(keySystemButton)
      if (keySystem.isDealerKeySystem) {
        navButtons.splice(1, 0, dealerNavButton)
      } else {
        navButtons.splice(1, 0, budgetNavButton)
      }
    }

    navButtons.push({
      name: 'Reports',
      active: false,
      icon: 'file',
      router: AppRoutingConfig.getGenericUrl('keySystemReports', structure.id, keySystem.id),
    })

    // navButtons.push({
    //   name: 'Audit Trail',
    //   active: false,
    //   icon: 'audit',
    //  router: AppRoutingConfig.getGenericUrl('keySystemHistory', structure.id, keySystem.id),
    // })

    navButtons.push({
      name: 'Audit Trail',
      active: false,
      icon: 'audit',
      router: AppRoutingConfig.getAuditTrailUrl('structureOrderDetails', structure.id, keySystem.id),
    })

    navButtons.push({
      name: 'Registry Numbers',
      active: false,
      icon: 'registry-number',
      router: AppRoutingConfig.getGenericUrl('keySystemRegistryNumbers', structure.id, keySystem.id),
    })

    navButtons.push({
      name: 'Quick Actions',
      active: false,
      icon: 'tools',
      router: AppRoutingConfig.getGenericUrl('keySystemTools', structure.id, keySystem.id),
    })

    navButtons
      .filter((n) => n.name === activeName)
      .map((n) => {
        n.active = true
      })

    this.navService.setEntities(navButtons)
  }
}
